import { Component } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, takeWhile } from 'rxjs';

import { YesNoDialogComponent } from '@app/shared';
import { ApplicationsService, IApplication } from '@app/core/applications';
import { ApplicationDialogComponent } from '../application-dialog/application-dialog.component';

@Component({
  selector: 'app-application-list',
  templateUrl: './application-list.component.html',
})
export class ApplicationListComponent {
  public records$: Subject<IApplication[]>;
  public selectedRecords: IApplication[];

  private destroyed: boolean;

  constructor(
    private service: ApplicationsService,
    private dialogService: DialogService
  ) {
    this.records$ = new Subject();
    this.loadRecords();
  }

  private loadRecords(): void {
    this.selectedRecords = [];

    this.service
      .getApplications()
      .pipe(takeWhile(() => !this.destroyed))
      .subscribe((records) => {
        this.records$.next(records);
      });
  }

  public onRowEdit(application: IApplication): void {
    this.dialogService
      .open(ApplicationDialogComponent, {
        data: {
          application,
        },
        height: '600px',
        width: '800px',
        header: 'Editar aplicación',
      })
      .onClose.pipe(takeWhile(() => !this.destroyed))
      .subscribe((record) => {
        if (record) {
          this.loadRecords();
        }
      });
  }

  public deleteSelected(): void {
    this.dialogService
      .open(YesNoDialogComponent, {
        height: '300px',
        width: '300px',
        header: 'Eliminar aplicación/es',
        data: {
          message: '¿Eliminar aplicaciones seleccionadas?',
        },
      })
      .onClose.pipe(takeWhile(() => !this.destroyed))
      .subscribe((result) => {
        if (result) {
          this.service
            .deleteApplications(this.selectedRecords.map((r) => r.id))
            .pipe(takeWhile(() => !this.destroyed))
            .subscribe(() => {
              this.loadRecords();
            });
        }
      });
  }

  public newRecord(): void {
    this.dialogService
      .open(ApplicationDialogComponent, {
        height: '600px',
        width: '800px',
        header: 'Nueva aplicación',
      })
      .onClose.pipe(takeWhile(() => !this.destroyed))
      .subscribe((record) => {
        if (record) {
          this.loadRecords();
        }
      });
  }

  public ngOnDestroy(): void {
    this.destroyed = true;
  }
}
